import axios from 'axios';

import BaseMitUserModel from '../models/BaseMitUserModel.js';
import BaseMitPageLoadingService from './BaseMitPageLoadingService.js';
import {MitEventBus} from '../../main.js';

class BaseMitUserService {
  constructor() {
    this.userModel = null;
    this.getUserPromise = null;
  }
  login(){
      BaseMitPageLoadingService.showLoading(true);
      window.location.href = '/auth/provider';
  }
  isLoggedIn(){
    return this.userModel === null ? false : true;
  }
  getCurrentUser(){
    return new Promise ((resolve, reject) => {
      return resolve(this.userModel);
    });
  }
  clearCurrentUser(){
    return new Promise ((resolve, reject) => {
      this.userModel = null;
      return resolve(this.userModel);
    });
  }
  getUser() {
    if(this.getUserPromise){
      return this.getUserPromise;
    }
    this.getUserPromise = new Promise ((resolve, reject) => {
      if(this.userModel){
        this.getUserPromise = null;
        return resolve(this.userModel);
      }
      else{
        axios.get('/api/v1/profile')
          .then((response) => {
              this.userModel = new BaseMitUserModel(
                                      response.data.csailId,
                                      response.data.fname,
                                      response.data.lname,
                                      response.data.access,
                                      response.data.csailEmail,
                                      response.data.adminTicketExpire

              ).get();

              MitEventBus.$emit(MitEventBus.EVENTS.USER_SERVICE__USER_CHANGED, this.userModel);

              this.getUserPromise = null;

              return resolve(this.userModel);
          })
          .catch((error) => {
            this.userModel = null
            this.getUserPromise = null;

            if (error && error.response && error.response.status === 401) {
              //This is not technically an error, lets catch the unauth and just set the user to null to indicate no user is logged in.
              return resolve(this.userModel);
            }
            this.userModel = null
            return reject(error);

          });
      }

    });
    return this.getUserPromise;
  }

}

export default new BaseMitUserService();
